import React from "react";
import {Layout} from "../layouts";
import SupportContactDetails from "@/components/support/support-contact";
import SupportHeader from "@/components/support/support-header";
import SupportFAQ from "@/components/support/faq";

const Support: React.FC = () => {
    return (
        <Layout page={"support"}>
            <SupportHeader />
            <SupportContactDetails />
            <SupportFAQ />
        </Layout>
    )
}

export default Support
